"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrowserStorageInfoCategory = void 0;
const constants_1 = require("./constants");
const isBrowserStorageInfoCategory = (category) => {
    return typeof category === 'string' && category in constants_1.DEFAULT_CONSENT_GROUPS;
};
exports.isBrowserStorageInfoCategory = isBrowserStorageInfoCategory;
//# sourceMappingURL=isBrowserStorageInfoCategory.js.map